function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "elotech-rh",
  d: "M197.951,217.089a6.664,6.664,0,0,1-6.654-7.022,6.922,6.922,0,0,1,7.033-6.308h20.992a28.7,28.7,0,1,0-38.346.054,46.345,46.345,0,0,0-27.2,42.66h92.689A46.088,46.088,0,0,0,236.3,217.089Z",
  transform: "translate(-153.774 -153.779)"
});

const SvgLogoOxyRecursosHumanos = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 92.693,
    height: 92.693,
    viewBox: "0 0 92.693 92.693",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogoOxyRecursosHumanos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-oxy-recursos-humanos.e94bc645.svg";
export { ForwardRef as ReactComponent };